import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { IUserCredentials } from '../services/pre-login.model';
import { LoggedInUserDeails } from '../services/login.model';



@Injectable({
  providedIn: 'root'
})
export class UserCredentialService {

  constructor(private httpclient: HttpClient, private httpHeaderService: HttpHeadersService){}
  post(userCredentials: IUserCredentials): Observable <LoggedInUserDeails>{
    const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
    const result = this.httpclient.post(environment.servicePath + '/login', userCredentials, { headers});
    return result as Observable<LoggedInUserDeails>;

  }

}
